// Единицы и разделитель принимаются строками, а не через `t()`, чтобы функция
// была пригодна вне setup() компонента.
//
// Время показываем в часах с десятичной долей, округлённым до получаса:
// «5,5 ч», «6 ч», «0,5 ч». Оценка Tobler точна до минуты, но «2 ч 11 мин»
// выглядит точнее, чем есть на самом деле (фитнес/вес рюкзака/погода двигают
// реальное число). Округление вверх, а не к ближайшему, не занижает
// ожидаемое время похода.
export const formatHikingDuration = (
  minutes: number | null | undefined,
  hourUnit: string,
  decimalSeparator = "."
): string | null => {
  if (minutes == null || minutes <= 0) return null;
  const hours = (Math.ceil(minutes / 30) * 30) / 60;
  return `${String(hours).replace(".", decimalSeparator)} ${hourUnit}`;
};
